import { Select } from 'components/Form/subcomponents/Select';
import styled from 'styled-components';
import { medias } from 'assets/styled/tokens';
import selectIcon from 'assets/icons/select-dropdown.svg';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
export const MenuContainer = styled.div`
  position: relative;
  width: 100%;
  @media (min-width: ${medias.desktopSm}) {
    display: none;
    width: 100vw;
  }
`;
export const StyledFormGroup = styled(FormGroup)``;
export const CompanySelect = styled(Select)`
  //position: absolute !important;
  border: 1px solid #ffffff;
  height: 32px;
  width: 100%;
  border-radius: 4px;
  //top: 55px;
  input {
    background: url(${selectIcon}) right 10px center / 8px 4px no-repeat, #ffffff;
    //color: #ffffff;
  }
  ul {
    margin-top: 32px;
    //background-color: #ffffff;
    //border: 1px solid #ffffff;
    border-radius: 0 0 4px 4px;
    section {
      li {
        &:hover {
          background-color: #1e1e1e;
        }
        label {
          color: #ffffff;
        }
      }
    }
  }
`;
export const DropdownButton = styled.button`
  border: 1px solid #ffffff;
  background-color: #1e1e1e;
  height: 32px;
  width: 32px;
  position: absolute;
  color: #ffffff;
  font-size: 20px;
  letter-spacing: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 7px;
  align-items: center;
  border-radius: 4px;
  right: 0px;
  top: -60px;
  padding: 4px 4px 6px 4px;
`;

export const DropDownMenu = styled.div`
  width: 100vw;
  height: 100vh;
  background: #1e1e1e;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: left;
  border-top: 1px solid #47403b;
  color: #ffffff;
  position: fixed;
  //border-radius: 5px;
  padding: 18px;
  right: 0;
  top: 64px;
  display: ${props => (props.isOpen ? 'flex' : 'none')};
  flex-direction: column;
  //justify-content: space-between;
  z-index: 10;
  svg {
  }
`;
export const MenuItem = styled.button`
  text-transform: uppercase;
  font-family: Blinker;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #ffffff;
  border: none;
  padding: 0;
  height: 48px;
  border-bottom: 1px solid #47403b;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CompanyLogo = styled.img`
  height: 92px;
  width: 92px;
  border-radius: 5px;
  margin: 9px 0 27px 0;
`;
export const MenuItemLogo = styled.button`
  text-transform: uppercase;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #ffffff;
  border: none;
  padding: 0;
  height: 148px;
  border-bottom: 1px solid #47403b;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
